import { render, staticRenderFns } from "./Tree.vue?vue&type=template&id=077c2615&scoped=true"
import script from "./Tree.vue?vue&type=script&lang=js"
export * from "./Tree.vue?vue&type=script&lang=js"
import style0 from "./Tree.vue?vue&type=style&index=0&id=077c2615&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077c2615",
  null
  
)

export default component.exports